import checkout from "./form";

const {
  formField: {
    year,
    declarationTime,
    taxpayerName,
    taxId1,
    address,
    province,
    district,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    address2,
    province2,
    district2,
    phone2,
    fax2,
    email2,
    contract,
    date,
    organ1,
    organ2,
    certificate,
    timeSign,
    signer,
    fullName,
  },
} = checkout;

const initialValues = {
  [year.name]: "",
  [declarationTime.name]: "",
  [phone2.name]: "",
  [fax2.name]: "",
  [email2.name]: "",
  [contract.name]: "",
  [date.name]: "",
  [organ1.name]: "",
  [organ2.name]: "",
  [address2.name]: "",
  [district2.name]: "",
  [province2.name]: "",
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [district.name]: "",
  [province.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [address.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
